import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { getAllIpsLocations, getAssetsByIpsLocationId } from '../../../api';
import ProgressBar from '../../common/progress_bar';

import { Row } from 'react-bootstrap';
import {
  SearchAndDropdownComponent,
  commonFilter,
  commonSorter,
  composeFilters,
  searchAndDropDownFilters,
  searchAndDropDownOnFilters,
} from 'utils/AntdTableFunctions';
import { Empty, Table } from 'antd';
import ProgressBarComp from 'containers/common/ProgressBarComp';

function AssetIPSLocation(props) {
  const [ipslocations, setIpslocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      const { id } = props.project;
      const ipslocationsData = await getAllIpsLocations(id);

      setIpslocations(ipslocationsData);

      setLoading(false);
    }
    getData();

    return () => setLoading(true);
  }, [props]);

  async function selectedIpsLocation(e, ipslocation) {
    e.preventDefault();

    const { match } = props;
    const { id } = props.project;
    let AssetsByIpsLocationRequest = {};
    AssetsByIpsLocationRequest.projectId = id;
    AssetsByIpsLocationRequest.ipsLocationId = ipslocation.id;
    const assets = await getAssetsByIpsLocationId(AssetsByIpsLocationRequest);
    const projectStatus = match.params.state;
    props.setSelectedAssets(assets);
    props.setSelectedIpsLocation(ipslocation);
    props.history.push(
      `/${projectStatus}/${id}/assettasks/ipslocations/${ipslocation.id}`
    );
  }

  const IPSLocationCellFormatter = (text, record) => {
    return (
      <a href='#' onClick={(e) => selectedIpsLocation(e, record)}>
        {text}
      </a>
    );
  };
  const statusFormatter = (text, record) => {
    // return text < 100 ? (
    //   <ProgressBar percentage={text} />
    // ) : (
    //   <ProgressBar percentage={text} color={'success'} />
    // );
    return <ProgressBarComp
    progressBarProps={[{ bgcolor: 'green', taskPercent: Number(record.status).toFixed(2) },
    { bgcolor: 'gray', taskPercent: Number(record.inCompStatus).toFixed(2) },
    { bgcolor: 'yellow', taskPercent: Number(record.tempStatus).toFixed(2) }
    ]}
    style={{
      borderRadius: '.25rem',
      height: '1rem',
      overflow: 'hidden',
      fontSize: '.75rem',
      color: 'black',//'#fff',
      width: '100%'
    }}
    showtext={true}
  />
  };

  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'IPS Location',
      render: IPSLocationCellFormatter,
      filters: searchAndDropDownFilters('name', ipslocations),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'name'),

      sorter: (a, b) => commonSorter(a, b, 'name'),
    },
    {
      dataIndex: 'noOfAssets',
      key: 'noOfAssets',
      title: '# of Assets',

      filters: composeFilters('noOfAssets', ipslocations),

      onFilter: (value, record) => commonFilter(value, record, 'noOfAssets'),
      sorter: (a, b) => commonSorter(a, b, 'noOfAssets'),
    },
    {
      dataIndex: 'status',
      key: 'status',
      title: 'Status',
      render: statusFormatter,
    },
  ];

  return (
    <div className='container-fluid'>
      {/* <Row
        className='justify-content-middle'
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          fontStyle: 'italic',
          fontWeight: 'bold',
          marginBottom: 12,
          marginTop: 20,
        }}
      >
        <i
          className='fa fa-info-circle'
          style={{ color: 'red', paddingRight: '3px' }}
          aria-hidden='true'
        ></i>{' '}
        Note: The % Calculations on this tab include tasks Signed and Marked
        N/A.
      </Row> */}

      <div className='row mb-5'>
        <div className='table-responsive assets-task-container'>
          <Table
            columns={columns}
            dataSource={ipslocations}
            pagination={false}
            locale={{
              emptyText: loading ? (
                <Empty description={<h6>Loading</h6>} />
              ) : (
                <Empty description={<h6>No IPS Locations Found</h6>} />
              ),
            }}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(AssetIPSLocation);